import Menu from '../../components/Menu/Menu';
import useAuth from '../../hooks/useAuth';
import './Misc.scss';

// const Misc = ({ title, options }) => {
const Misc = () => {
    return (
        <div id='misc'>
            <div className='centered-container'>
                <Menu title="Misc" options={[
                    { name: 'Ev Cars', path: '/misc/evcars' },
                    { name: 'Minigames', path: '/misc/minigames' },
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
};

export default Misc;